var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
export default class HighSchoolService {
    static searchAll(search, max = 50, sort = "name") {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/highSchools/search/findByNameLike", {
                params: { search, max, sort },
            });
            return response.data._embedded.highSchools;
        });
    }
    static findAllById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get(`/highSchools/search/findByIdIn?ids=${ids.join(",")}`);
            return response.data._embedded.highSchools;
        });
    }
    static search(search = {}, options = {}) {
        return FetchService.getPagedResponse("/aviso/highSchool/search", {
            ids: search === null || search === void 0 ? void 0 : search.ids,
            ceebCodes: search === null || search === void 0 ? void 0 : search.ceebCodes,
            names: search === null || search === void 0 ? void 0 : search.names,
            srcSystemIds: search === null || search === void 0 ? void 0 : search.srcSystemIds,
            query: search === null || search === void 0 ? void 0 : search.query,
            zipCode: search === null || search === void 0 ? void 0 : search.zipCode,
            state: search === null || search === void 0 ? void 0 : search.state,
            max: options === null || options === void 0 ? void 0 : options.max,
            offset: options === null || options === void 0 ? void 0 : options.offset,
            sort: options === null || options === void 0 ? void 0 : options.sort,
            order: options === null || options === void 0 ? void 0 : options.order,
        });
    }
}
